export default {"src":"/newStatic/_next/static/media/pattern-7.8903a9c8.svg","height":68,"width":1280};